import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import Link from "next/link";
import { ProfileIcon } from "../header/profileIcon";
import { LoginInfoModal } from "../loginInfoModal/loginInfoModal";

export const UtilityPanel = ({
  session,
  handleLoginModal,
  loginModalIsOpen,
  setLoginModalIsOpen,
  deleteSession,
  merchantColor,
  toCheckoutAfterLogin,
  merchant,
}: any) => {
  return (
    <>
      {session ? (
        <Popover className="relative">
          <PopoverButton
            className={[
              "flex",
              "items-center",
              "gap-x-2",
              "leading-6",
              "text-gray-900",
              "hover:bg-gray-50",
              "font-normal text-base leading-6",
            ].join(" ")}
          >
            <ProfileIcon />
          </PopoverButton>
          <PopoverPanel
            transition
            className="absolute -right-8 top-full z-20 mt-3 w-max overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <div className="p-3">
              <div className="group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-gray-50">
                <div className="flex-auto">
                  <Link
                    href={`/customer-profile`}
                    className={[
                      "block text-gray-900",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                  >
                    Account
                    <span className="absolute inset-0" />
                  </Link>
                </div>
              </div>
              <div className="group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-gray-50">
                <div className="flex-auto">
                  <Link
                    href={
                      merchant.isService ? "/my-appointments" : "/my-orders"
                    }
                    className={[
                      "block text-gray-900",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                  >
                    My orders
                    <span className="absolute inset-0" />
                  </Link>
                </div>
              </div>
              <div className="group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-gray-50">
                <div className="flex-auto">
                  <button
                    className={[
                      "block text-gray-900",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                    onClick={() => {
                      deleteSession();
                    }}
                  >
                    <p>Log out</p>
                    <span className="absolute inset-0" />
                  </button>
                </div>
              </div>
            </div>
          </PopoverPanel>
        </Popover>
      ) : (
        <div className="flex flex-col justify-center items-center">
          <button
            onClick={() => {
              handleLoginModal(false);
            }}
          >
            <ProfileIcon />
          </button>
          <LoginInfoModal
            isOpen={loginModalIsOpen}
            onRequestClose={() => setLoginModalIsOpen(false)}
            merchantColor={merchantColor}
            toCheckoutAfterLogin={toCheckoutAfterLogin}
            merchant={merchant}
          />
        </div>
      )}
    </>
  );
};
